/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(ActivityTypeSummationGroupMappingDataService.Id, ActivityTypeSummationGroupMappingDataService);

    ActivityTypeSummationGroupMappingDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

export class ActivityTypeSummationGroupMappingDataService extends base.BaseDataService<Nema.Crew.Model.ActivityTypeSummationGroupMapping> implements IActivityTypeSummationGroupMappingDataService {

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "activityTypeSummationGroupMappingDataService";

    public get EntityName(): string {
        return "ActivityTypeSummationGroupMapping";
    }

    public get EntitiesName(): string {
        return "ActivityTypeSummationGroupMappings";
    }

    /**
     * Override the getAll, since WorkGroupPerson do not 
     * have the Active and SortTag properties.
     */
    public getBySummationGroupId(summationGroupId: number, _active: boolean = true) {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .where("ActivityTypeSummationGroupId", "==", summationGroupId)
            .using(this.entityManager);

        var promise = entityQuery.execute()
        // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
                self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
                return self.entityCollection;
        });

        return promise;
    }
}

export interface IActivityTypeSummationGroupMappingDataService extends base.IDataService<Nema.Crew.Model.ActivityTypeSummationGroupMapping> {
    EntityName: string;

    getBySummationGroupId(summationGroupId: number): ng.IPromise<any>;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/activitytypesummationgroupmapping.dataservice.ts